import Lottie from 'react-lottie';
import loading from './Loading.json';

export default function Spinner() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="flex h-screen w-screen justify-center items-center absolute left-0">
      <div className="h-[80px] w-[80px]">
        <Lottie options={defaultOptions} />
      </div>
    </div>
  );
}
